import {API} from "aws-amplify";
import {awsApiName} from "../../shared/amplify/amplify-utils";
import {Title} from "../../entity/model/title";
import {RequestBody} from "../../entity/core/request-body";
import {UniqueIdentifier} from "@dnd-kit/core";
import {TitleTemplate} from "../../entity/model/title-template";

export default class SectionAgent {
    moveSection = async (organizationId: string, requestBody: RequestBody, titleId?: string, templateId?: string): Promise<Title | TitleTemplate> => {
        if (titleId)
            return await API.put(awsApiName, `/organizations/${organizationId}/project-titles/${titleId}/sections/order`, requestBody);
        else
            return await API.patch(awsApiName, `/organizations/${organizationId}/title-templates/${templateId}/sections/order`, requestBody);
    }

    deleteSection = async (organizationId: string, sectionId: UniqueIdentifier,titleId?: string, templateId?: string): Promise<void> => {
        return await API.del(awsApiName, `/organizations/${organizationId}${titleId? `/project-titles/${titleId}` : `/title-templates/${templateId}`}/sections/${sectionId}`, {});
    }

    addNewSection = async (organizationId: string, templateId: string, requestBody: RequestBody): Promise<TitleTemplate> => {
        return await API.post(awsApiName, `/organizations/${organizationId}/title-templates/${templateId}/sections`, requestBody);
    }
}
